import { render, staticRenderFns } from "./AddShop.vue?vue&type=template&id=598f2092&scoped=true"
import script from "./AddShop.vue?vue&type=script&lang=js"
export * from "./AddShop.vue?vue&type=script&lang=js"
import style0 from "./AddShop.vue?vue&type=style&index=0&id=598f2092&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "598f2092",
  null
  
)

export default component.exports